<div class="main-container" *ngIf="!isLoading" data-cy="forms-builder-polished-container">
  <div style="flex-basis: 220px; display: flex;" data-cy="forms-builder-polished-sidebar">
    <div class="form-detail-container" data-cy="forms-builder-polished-form-details">

      <div data-cy="forms-builder-polished-header">
        <h5 class="form-detail-title" data-cy="forms-builder-polished-title">Form Builder.</h5>
        <mat-spinner class="form-detail-spinner" *ngIf="cfgFormIsLoading" [diameter]="20" data-cy="forms-builder-polished-spinner"></mat-spinner>
        <div style="display: flex;" class="form-action-button-container" data-cy="forms-builder-polished-actions">
          <div *ngIf="isShiftPressed" style="cursor: pointer; color: var(--tdo-secondary); margin-top: 8px; margin-right: 8px;" (click)="deleteForm()" data-cy="forms-builder-polished-delete-icon"><mat-icon>delete</mat-icon></div>
          <button mat-icon-button [disabled]="!formIsEditable || !selectedCfgForm" (click)="saveFormData()" matTooltip="Save all changes" data-cy="forms-builder-polished-save-button">
            <i class="material-icons">save</i>
          </button>
          <button mat-icon-button [disabled]="!selectedCfgForm" (click)="editFormButtonPressed()" matTooltip="Edit selected form" data-cy="forms-builder-polished-edit-button">
            <i class="material-icons">edit</i>
          </button>
          <button mat-icon-button matTooltip="Create a new form" (click)="createNewFormButtonPressed()" data-cy="forms-builder-polished-add-button"><i class="material-icons">add</i></button>
          <button mat-icon-button [disabled]="!selectedCfgForm"
                  (click)="clearChanges()"
                  matTooltip="Clear all unsaved changes" data-cy="forms-builder-polished-undo-button">
            <i class="material-icons">undo</i>
          </button>
        </div>
      </div>

      <div class="form-search-container" data-cy="forms-builder-polished-search-container">
        <div data-cy="forms-builder-polished-search-input-container">
          <input class="form-search-input" type="text" placeholder="Search for form by name"
                 [(ngModel)]="formSearchKeyword"
                 (input)="searchForForm()" data-cy="forms-builder-polished-search-input" />
        </div>
        <div class="form-search-results" data-cy="forms-builder-polished-search-results">
          <div class="search-spinner-holder" *ngIf="isSearchingForForms" data-cy="forms-builder-polished-search-spinner">
            <mat-spinner [diameter]="20" data-cy="forms-builder-polished-spinner-small"></mat-spinner>
          </div>
          <div *ngIf="!isSearchingForForms" data-cy="forms-builder-polished-results-content">
            <div class="search-message" *ngIf="!formSearchResults" data-cy="forms-builder-polished-empty-message">
            </div>
            <div class="search-message" *ngIf="formSearchResults && !formSearchResults.length" data-cy="forms-builder-polished-no-results">
              No forms found
            </div>
            <div class="form-preview" (click)="selectAndFetchCfgForm(formPreview.DFormId)" [class.selected]="formPreview.DFormId == selectedCfgFormPreviewId"
                 *ngFor="let formPreview of formSearchResults; let i = index" data-cy="forms-builder-polished-form-preview-{{i}}">
              {{ formPreview.DFormName }}
            </div>
          </div>
        </div>
      </div>

      <div class="form-input-container" data-cy="forms-builder-polished-form-input">

        <div class="form-name-input-container" data-cy="forms-builder-polished-name-container">
          <input class="form-search-input" type="text" placeholder="Form name"
                 [disabled]="!formIsEditable && selectedCfgForm !== null" [value]="selectedCfgForm?.DFormName" (input)="selectedCfgForm.DFormName = $event.target.value" data-cy="forms-builder-polished-form-name" />
        </div>
        <div style="display: flex; width: 100%;" *ngIf="selectedCfgForm" class="ui-dark-background" data-cy="forms-builder-polished-form-properties">
          <div style="flex: 1; display: flex; flex-direction: column;" data-cy="forms-builder-polished-form-left-properties">
            <div style="display: flex; width: 100%;" data-cy="forms-builder-polished-category-container">
              <div style="flex-basis: 100px; text-align: right; margin-top: 3px; font-weight: 500;" data-cy="forms-builder-polished-category-label">Category:</div>
              <div style="flex-basis: 6px;"></div>
              <div style="flex: 1;" data-cy="forms-builder-polished-category-select">
                <tdo-dropdown-v2 placeholder="" displayProperty="ItemDisplayValue"
                                 [datasource]="categoryEnums" [isDisabled]="!formIsEditable"
                                 [value]="getCategoryValue(selectedCfgForm?.enumFormCategoryID)"
                                 (selectionChange)="selectedCfgForm.enumFormCategoryID = $event.value.ValidValueItemId;"
                                 data-cy="forms-builder-polished-category-dropdown">
                </tdo-dropdown-v2>
              </div>
            </div>
            <div style="display: flex; width: 100%;" data-cy="forms-builder-polished-datasource-container">
              <div style="flex-basis: 100px; text-align: right; margin-top: 3px; font-weight: 500;" data-cy="forms-builder-polished-datasource-label">Data Source:</div>
              <div style="flex-basis: 6px;"></div>
              <div style="flex: 1;" data-cy="forms-builder-polished-datasource-select">
                <tdo-dropdown-v2 placeholder="" displayProperty="name"
                                 [datasource]="cfgFormDataSourceList" [isDisabled]="!formIsEditable"
                                 [value]="getDataSourceValue(selectedCfgForm?.enumFormDataSourceID)"
                                 (selectionChange)="selectedCfgForm.enumFormDataSourceID = $event.value.id;"
                                 data-cy="forms-builder-polished-datasource-dropdown">
                </tdo-dropdown-v2>
              </div>
            </div>
            <div *ngIf="selectedCfgForm?.enumFormDataSourceID == '00000030-1000-0000-0000-000000000002'" style="display: flex; width: 100%;" data-cy="forms-builder-polished-type-container">
              <div style="flex-basis: 100px; text-align: right; margin-top: 3px; font-weight: 500;" data-cy="forms-builder-polished-type-label">Type:</div>
              <div style="flex-basis: 6px;"></div>
              <div style="flex: 1;" data-cy="forms-builder-polished-type-select">
                <tdo-dropdown-v2 placeholder="" displayProperty="ItemDisplayValue"
                                 [datasource]="customEnums" [isDisabled]="!formIsEditable"
                                 [value]="getCustomValue(selectedCfgForm?.enumCustomFormID)"
                                 (selectionChange)="selectedCfgForm.enumCustomFormID = $event.value.ValidValueItemId;"
                                 data-cy="forms-builder-polished-type-dropdown">
                </tdo-dropdown-v2>
              </div>
            </div>
            <mat-checkbox style="margin-left: 8px;" [disabled]="!formIsEditable" [(ngModel)]="selectedCfgForm.isRequireSignature" data-cy="forms-builder-polished-signature-checkbox">Require Signature</mat-checkbox>
            <mat-checkbox style="margin-left: 8px;" [disabled]="!formIsEditable" [(ngModel)]="selectedCfgForm.isSubmissionRequired" data-cy="forms-builder-polished-submission-checkbox">Require Submission</mat-checkbox>
            <mat-checkbox style="margin-left: 8px;" [disabled]="!formIsEditable" [(ngModel)]="selectedCfgForm.isToothRequired" data-cy="forms-builder-polished-tooth-checkbox">Require Tooth</mat-checkbox>
          </div>
          <div style="flex-basis: 6px;"></div>
          <div style="flex: 1; display: flex; flex-direction: column;" data-cy="forms-builder-polished-form-right-properties">
            <div style="display: flex; width: 100%;" *ngIf="selectedCfgForm?.enumFormDataSourceID !== '00000030-1000-0000-0000-000000000002'" data-cy="forms-builder-polished-version-container">
              <div style="flex-basis: 100px; text-align: right; margin-top: 3px; font-weight: 500;" data-cy="forms-builder-polished-version-label">Version:</div>
              <div style="flex-basis: 6px;"></div>
              <div style="flex: 1;" data-cy="forms-builder-polished-version-select">
                <tdo-dropdown-v2 placeholder="" displayProperty="Version"
                                 [datasource]="selectedCfgForm?.cfgDFormVersions" [isDisabled]="!formIsEditable"
                                 [value]="getVersion(selectedVersionId)"
                                 (selectionChange)="selectCfgFormVersion($event.value);"
                                 data-cy="forms-builder-polished-version-dropdown">
                </tdo-dropdown-v2>
              </div>
            </div>
            <div style="display: flex; width: 100%;" *ngIf="selectedCfgForm?.enumFormDataSourceID !== '00000030-1000-0000-0000-000000000002'" data-cy="forms-builder-polished-status-container">
              <div style="flex-basis: 100px; text-align: right; margin-top: 3px; font-weight: 500;" data-cy="forms-builder-polished-status-label">Status:</div>
              <div style="flex-basis: 6px;"></div>
              <div style="flex: 1;" data-cy="forms-builder-polished-status-select">
                <tdo-dropdown-v2 placeholder="" displayProperty="name"
                                 [datasource]="cfgFormVersionStatusList" [isDisabled]="!formIsEditable"
                                 [value]="getVersionStatus(this.selectedCfgFormVersion?.enumDFormBuildStatusID)"
                                 (selectionChange)="selectCfgFormVersionStatus($event.value)"
                                 data-cy="forms-builder-polished-status-dropdown">
                </tdo-dropdown-v2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-version-selector-container" *ngIf="awd" data-cy="forms-builder-polished-version-selector">
        <mat-form-field class="existing-form-select">
          <mat-label>Select a form</mat-label>
          <mat-select *ngIf="!cfgFormPreviewSelectListIsLoading" [(ngModel)]="selectedCfgFormPreviewId">
            <mat-option *ngFor="let cfgFormPreview of cfgFormPreviewSelectList"
                        [value]="cfgFormPreview.DFormId">
              <div class="cfg-form-select-button cfg-form-button-name"
                   (click)="selectAndFetchCfgForm(cfgFormPreview.DFormId)">
                {{ cfgFormPreview.DFormName }}
              </div>
            </mat-option>
            <mat-option [value]="null">
              <div class="cfg-form-select-button" (click)="createAndSelectNewCfgForm()"
                   matTooltip="Create a new form"><i class="material-icons">add</i></div>
            </mat-option>
          </mat-select>
          <mat-select *ngIf="cfgFormPreviewSelectListIsLoading">
            <mat-option [value]="null">
              <mat-spinner [diameter]="20"></mat-spinner>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div>
          <mat-form-field class="form-input-small margin-left-side">
            <input matInput type="number" placeholder="Revision" *ngIf="selectedCfgFormVersion"
                   [(ngModel)]="selectedCfgFormVersion.Revision">
            <input matInput type="number" placeholder="Revision" *ngIf="!selectedCfgFormVersion" disabled>
          </mat-form-field>
        </div>

        <mat-form-field class="status-form-select form-select">
          <mat-label>Status</mat-label>
          <mat-select *ngIf="selectedCfgFormVersion" [(ngModel)]="activeFormVersionStatus">
            <mat-option *ngFor="let formStatus of cfgFormVersionStatusList" [value]="formStatus.name">
              <div class="cfg-form-select-button cfg-form-button-name"
                   (click)="selectCfgFormVersionStatus(formStatus)">
                {{ formStatus.name }}
              </div>
            </mat-option>
          </mat-select>
          <mat-select *ngIf="!selectedCfgFormVersion" [disabled]="!selectedCfgFormVersion">
            <mat-option [value]="null">
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>

    </div>
    <div style="flex-basis: 5px; min-width: 5px;"></div>
    
    <!-- PARAGRAPH DETAILS -->
    <div class="paragraph-detail-container" data-cy="forms-builder-polished-paragraph-details">

      <div data-cy="forms-builder-polished-paragraph-header">
        <h5 class="form-detail-title" data-cy="forms-builder-polished-paragraph-title">Paragraphs</h5>
        <div class="form-action-button-container" data-cy="forms-builder-polished-paragraph-actions">
          <button mat-icon-button (click)="openPreview()"
                  matTooltip="Preview form version" [disabled]="!selectedCfgFormVersion" data-cy="forms-builder-polished-preview-button">
            <i class="material-icons">visibility</i>
          </button>
          <button mat-icon-button matTooltip="Create a new paragraph" [disabled]="!formIsEditable || !selectedCfgFormVersion" (click)="createNewDFormParagraph()" data-cy="forms-builder-polished-add-paragraph-button">
            <i class="material-icons">add</i>
          </button>
          <button mat-icon-button [disabled]="!formIsEditable || !selectedCfgFormParagraph"
                  matTooltip="Delete selected paragraph" (click)="deleteParagraph()" data-cy="forms-builder-polished-delete-paragraph-button">
            <i class="material-icons">clear</i>
          </button>
        </div>
      </div>

      <div *ngIf="!selectedCfgFormVersion" class="no-paragraph-message" data-cy="forms-builder-polished-no-paragraph-message">
        Select a form and a version to load paragraphs
      </div>

      <div class="paragraph-selector-container" *ngIf="selectedCfgFormVersion" data-cy="forms-builder-polished-paragraph-selector">
        <div class="paragraph-results" data-cy="forms-builder-polished-paragraph-results">
          <div *ngIf="selectedCfgFormVersion"
               (cdkDropListDropped)="paragraphReOrderEvent($event, selectedCfgFormVersion.cfgDFormParagraphs)"
               class="paragraph-boundary"
               cdkDropList
               data-cy="forms-builder-polished-paragraph-list">
            <div class="paragraph-preview" [cdkDragDisabled]="!formIsEditable"
                 cdkDragBoundary=".paragraph-boundary" cdkDrag
                 cdkDragLockAxis="y"
                 [class.selected]="paragraph.DFormParagraphId == selectedParagraphId"
                 *ngFor="let paragraph of selectedCfgFormVersion.cfgDFormParagraphs; let i = index"
                 data-cy="forms-builder-polished-paragraph-item-{{i}}">
              <div (click)="selectDFormParagraph(paragraph)" class="paragraph-name-text" data-cy="forms-builder-polished-paragraph-name-{{i}}">
                {{ paragraph.ParagraphName }}
              </div>
              <div class="dragable-paragraph-container" *ngIf="formIsEditable" cdkDragHandle data-cy="forms-builder-polished-paragraph-drag-{{i}}">
                <i class="material-icons">reorder</i>
              </div>
              <div (click)="selectDFormParagraph(paragraph)" class="dragable-paragraph-container-disabled"
                   *ngIf="!formIsEditable" data-cy="forms-builder-polished-paragraph-disabled-drag-{{i}}"><i class="material-icons">reorder</i></div>
            </div>
          </div>
        </div>

        <div class="paragraph-select-container" *ngIf="awdawd">
          <mat-form-field class="existing-form-select">
            <mat-label>Select a paragraph</mat-label>
            <mat-select *ngIf="selectedCfgFormVersion" [(ngModel)]="selectedParagraphId">
              <mat-option *ngFor="let paragraph of selectedCfgFormVersion.cfgDFormParagraphs"
                          [value]="paragraph.DFormParagraphId">
                <div class="cfg-form-select-button cfg-form-button-name"
                     (click)="selectDFormParagraph(paragraph)">
                  {{ paragraph.ParagraphName }}
                </div>
              </mat-option>
              <mat-option [value]="null">
                <div class="cfg-form-select-button" (click)="createNewDFormParagraph()"
                     matTooltip="Create a new paragraph"><i class="material-icons">add</i></div>
              </mat-option>
            </mat-select>
            <mat-select *ngIf="!selectedCfgFormVersion" [disabled]="true">
            </mat-select>
          </mat-form-field>
        </div>

      </div>

      <div class="form-input-container" *ngIf="selectedCfgFormVersion" data-cy="forms-builder-polished-paragraph-input">

        <div class="form-name-input-container" data-cy="forms-builder-polished-paragraph-name-container">
          <input class="form-search-input" type="text" placeholder="Select a Paragraph"
                 *ngIf="!selectedCfgFormParagraph" [disabled]="true" data-cy="forms-builder-polished-paragraph-name-disabled" />
          <input class="form-search-input" type="text" placeholder="Paragraph name"
                 *ngIf="selectedCfgFormParagraph" [disabled]="!formIsEditable"
                 [(ngModel)]="selectedCfgFormParagraph.ParagraphName" data-cy="forms-builder-polished-paragraph-name" />
        </div>

        <mat-form-field *ngIf="selectedCfgFormParagraph" data-cy="forms-builder-polished-orientation-field">
          <mat-label data-cy="forms-builder-polished-orientation-label">Orientation</mat-label>
          <mat-select *ngIf="selectedCfgFormParagraph"  [(ngModel)]="activeParagraphOrientation"
                      [disabled]="!formIsEditable" data-cy="forms-builder-polished-orientation-select">
            <mat-option *ngFor="let orientation of cfgFormParagraphOrientationList; let i = index" [value]="orientation.id" data-cy="forms-builder-polished-orientation-option-{{i}}">
              <div class="cfg-form-select-button cfg-form-button-name"
                   (click)="selectParagraphOrientation(orientation.id)" data-cy="forms-builder-polished-orientation-name-{{i}}">
                {{ orientation.name }}
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="selectedCfgFormParagraph" data-cy="forms-builder-polished-layout-field">
          <mat-label data-cy="forms-builder-polished-layout-label">Item Layout</mat-label>
          <mat-select *ngIf="selectedCfgFormParagraph" [(ngModel)]="activeParagraphItemLayout"
                      [disabled]="!formIsEditable" data-cy="forms-builder-polished-layout-select">
            <mat-option *ngFor="let layout of cfgFormItemLayoutList; let i = index" [value]="layout.id" data-cy="forms-builder-polished-layout-option-{{i}}">
              <div class="cfg-form-select-button cfg-form-button-name"
                   (click)="selectParagraphItemLayout(layout.id)" data-cy="forms-builder-polished-layout-name-{{i}}">
                {{ layout.name }}
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div *ngIf="selectedCfgFormParagraph" data-cy="forms-builder-polished-page-break-container">
          <mat-checkbox class="checkbox-button" [(ngModel)]="selectedCfgFormParagraph.PageBreakAfter" data-cy="forms-builder-polished-page-break-checkbox">
             Page break after paragraph
          </mat-checkbox>
        </div>

        <div *ngIf="selectedCfgFormParagraph && formIsEditable" data-cy="forms-builder-polished-repeatable-container">
          <mat-checkbox class="checkbox-button" [(ngModel)]="selectedCfgFormParagraph.isRepeting" data-cy="forms-builder-polished-repeatable-checkbox">
            Is repeatable
          </mat-checkbox>
        </div>

      </div>

    </div>
  </div>

  <!-- PARAGRAPH BUILDER -->
  <div class="paragraph-builder-wrapper" style="flex: 1; margin-top: 4px; overflow: hidden;" data-cy="forms-builder-polished-builder-wrapper">
    <div class="main-builder-content" style="height: 100%;" data-cy="forms-builder-polished-builder-content">
      <div class="paragraph-builder-container mat-elevation-z2" data-cy="forms-builder-polished-builder-container">
        <h5 data-cy="forms-builder-polished-builder-title">Paragraph Builder</h5>

        <div class="paragraph-row-boundary"
             *ngIf="selectedParagraphOrganizer"
             (cdkDropListDropped)="dropEventOnRow($event)"
             cdkDropList
             data-cy="forms-builder-polished-row-boundary">
          <div *ngFor="let row of selectedParagraphOrganizer; let i = index;"
               cdkDragLockAxis="y"
               cdkDragBoundary=".paragraph-row-boundary"
               [cdkDragDisabled]="!formIsEditable"
               cdkDrag
               data-cy="forms-builder-polished-row-{{i}}">
            <div data-cy="forms-builder-polished-row-content-{{i}}">
              <div class="paragraph-row"
                   cdkDropList
                   [cdkDropListConnectedTo]="connectedDragDropParagraphs"
                   [cdkDropListData]="row"
                   cdkDropListOrientation="horizontal"
                   (cdkDropListDropped)="dropEventInRow($event, row, i)"
                   id="paragraphRow{{i}}"
                   data-cy="forms-builder-polished-row-list-{{i}}">
                <div class="row-drag-handle" [class.disabled-draggable]="!formIsEditable" cdkDragHandle data-cy="forms-builder-polished-row-handle-{{i}}">
                  <i class="material-icons row-drag-icon">reorder</i>
                </div>
                <div *ngFor="let item of row; let j = index"
                     class="inline"
                     cdkDrag
                     [class.disabled-draggable]="!formIsEditable"
                     [cdkDragDisabled]="!formIsEditable"
                     data-cy="forms-builder-polished-item-{{i}}-{{j}}">
                  <div class="row-column draggable-item draggable-container"
                       [class.disabled-draggable]="!formIsEditable"
                       *ngIf="!item.xauditDeleted"
                       data-cy="forms-builder-polished-item-container-{{i}}-{{j}}">
                    <div class="item-details" matTooltipDisabled="{{item.DFormItemName.length <= 14}}"
                         matTooltip="{{item.DFormItemName}}" data-cy="forms-builder-polished-item-details-{{i}}-{{j}}">
                      {{ item.DFormItemName }}
                    </div>
                    <i class="material-icons item-type-icon"
                       matTooltip="{{getItemLabel(item).name}}" data-cy="forms-builder-polished-item-type-{{i}}-{{j}}">{{ getItemLabel(item).icon }}</i>
                    <i class="material-icons item-settings-icon" *ngIf="formIsEditable"
                       (click)="openItemDetailDetail(item, i, j)" data-cy="forms-builder-polished-item-settings-{{i}}-{{j}}">settings_application</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button *ngIf="formIsEditable"
                  mat-button
                  color="primary"
                  class="add-paragraph-row-button"
                  (click)="addParagraphRowToOrganizer()" 
                  data-cy="forms-builder-polished-add-row-button">
            <i class="material-icons">add</i>
          </button>
        </div>
      </div>
    </div>
    <div style="flex-basis: 6px;"></div>
    
    <!-- ITEM DRAWER -->
    <div class="item-drawer mat-elevation-z2" style="flex-basis: 300px; overflow: hidden; display: flex; flex-direction: column;" data-cy="forms-builder-polished-item-drawer">
      <div style="flex-basis: fit-content;" data-cy="forms-builder-polished-item-drawer-header">
        <h5 class="item-drawer-title" data-cy="forms-builder-polished-item-drawer-title">Items</h5>
        <i class="material-icons item-drawer-tooltip" *ngIf="selectedParagraphOrganizer && formIsEditable" matTooltip="Drag and drop items from this list into the paragraph builder to add them to a row." data-cy="forms-builder-polished-item-drawer-help">help</i>
      </div>
      <div id="itemListDropList" style="flex: 1; overflow-y: auto;"
           #cfgFormItemTypeDropList="cdkDropList"
           [cdkDropListConnectedTo]="connectedDragDropParagraphs"
           [cdkDropListData]="cfgFormItemTypeList"
           (cdkDropListDropped)="organizeItemTypeList()"
           cdkDropList
           data-cy="forms-builder-polished-item-list">
        <div class="item-picker-container draggable-container"
             *ngFor="let item of cfgFormItemTypeList; let i = index"
             [class.disabled-draggable]="!formIsEditable"
             [cdkDragDisabled]="!formIsEditable"
             cdkDrag
             data-cy="forms-builder-polished-item-template-{{i}}">
          <i class="material-icons item-picker-icon" data-cy="forms-builder-polished-item-icon-{{i}}">{{ item.icon }}</i>
          <div class="item-picker-name" data-cy="forms-builder-polished-item-name-{{i}}">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="spinner-container" *ngIf="isLoading" data-cy="forms-builder-polished-loading">
  <mat-spinner data-cy="forms-builder-polished-main-spinner"></mat-spinner>
</div>
